import { post } from "utils/Service";

import { AuthenticationTokens } from "./AuthenticationTypes";

// TODO: uniform way of handling in case storage is not supported!
if (typeof Storage !== "undefined") {
	//console.log("Local storage is supported.");
} else {
	//console.log("Local storage not supported.");
	// TODO: fall back to a session variable!
}

// TODO: do we want to expose this?
// Or maybe something that sets the token in the header?
export function getAccessToken(): string {
	return localStorage.getItem("accessToken") ?? "";
}

function getRefreshToken(): string {
	return localStorage.getItem("refreshToken") ?? "";
}

export function isLoggedIn(): boolean {
	// TODO: locally check validity?
	return getAccessToken() !== "";
}

export enum UserRole {
	USER = "USER",
	ADMIN = "ADMIN",
	OWNER = "OWNER"
}

export type Jwt = {
	sub: string;
	eula: string | boolean; // TODO: only for backwards compatibility.
	exp: number;
	user_id: number;
	organisation_id: number | undefined;
	user_role: UserRole | undefined;
};

export function parseJwt(token: string): Jwt | undefined {
	const base64Url = token.split(".")[1];
	if (base64Url === undefined) {
		return undefined;
	}

	try {
		const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

		const jsonPayload = decodeURIComponent(
			window
				.atob(base64)
				.split("")
				.map(function (c) {
					return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
				})
				.join("")
		);

		return JSON.parse(jsonPayload);
	} catch {
		return undefined;
	}
}

/**
 * @deprecated
 */
export function getLoggedInUser(): string {
	return parseJwt(getAccessToken())?.sub ?? "";
}

/**
 * @deprecated
 */
export function getLoggedInOrganisation(): number | undefined {
	return parseJwt(getAccessToken())?.organisation_id;
}

/**
 * @deprecated
 */
export function hasAcceptedEula(): boolean {
	const token = parseJwt(getAccessToken());
	return token?.eula === "true" || token?.eula === true;
}

/**
 * @deprecated
 */
export function isTokenExpired(): boolean {
	const token = parseJwt(getAccessToken());
	if (token === undefined) {
		return true;
	}
	// Include a small margin.
	return token.exp < Date.now() / 1000;
}

// TODO: provide a way for the caller to identify between success and failure!

export function register(email: string, password: string): Promise<void> {
	const requestOptions = {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ email, password })
	};

	return fetch("/api/auth/register", requestOptions).then(response => {
		// TODO: distinguish different problems/errors.
		if (response.status !== 200) {
			throw new Error(response.statusText);
		}
	});
}

export function activate(code: string): Promise<void> {
	const requestOptions = {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ code })
	};

	return fetch("/api/auth/activate", requestOptions).then(response => {
		if (response.status !== 200) {
			throw new Error(response.statusText);
		}
	});
}

export function sendPasswordResetLink(email: string): Promise<void> {
	const requestOptions = {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ email })
	};

	return fetch("/api/auth/request-password-reset", requestOptions).then(
		response => {
			if (response.status !== 200) {
				throw new Error(response.statusText);
			}
		}
	);
}

export function resetPassword(code: string, password: string): Promise<void> {
	const requestOptions = {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ code, password })
	};

	return fetch("/api/auth/reset-password", requestOptions).then(response => {
		if (response.status !== 200) {
			throw new Error(response.statusText);
		}
	});
}

export function loginOAuth(
	provider: string,
	code: string
): Promise<AuthenticationTokens> {
	return fetch(`/api/oauth2/${provider}/code?code=${code}`).then(response => {
		// TODO: distinguish different problems/errors.
		if (response.status !== 200) {
			throw new Error(response.statusText);
		}

		return response.json();
	});
}

export function getTokens(orgId?: number): Promise<AuthenticationTokens> {
	const requestOptions = {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			email: getLoggedInUser(),
			refreshToken: getRefreshToken(),
			organisationId: orgId
		})
	};

	return fetch("/api/auth/refresh", requestOptions).then(response => {
		// TODO: distinguish different problems/errors.
		if (response.status !== 200) {
			throw new Error(response.statusText);
		}

		return response.json();
	});
}

// TODO: signing eula should give you new tokens.
export function signEula(): Promise<void> {
	return post("/api/auth/eula", {}).then(response => {
		// TODO: distinguish different problems/errors.
		if (response.status !== 200) {
			throw new Error(response.statusText);
		}
	});
}
